"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTimelineWatchers = exports.coreTimelineReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const details_1 = require("./details/index.js");
const export_1 = require("./export/index.js");
const grouped_summary_1 = require("./grouped-summary/index.js");
const summary_1 = require("./summary/index.js");
const synopsis_1 = require("./synopsis/index.js");
const user_changes_1 = require("./user-changes/index.js");
exports.coreTimelineReducers = (0, redux_1.combineReducers)({
    details: details_1.coreTimelineDetailsReducers,
    export: export_1.coreTimelineExportReducers,
    groupedSummary: grouped_summary_1.coreTimelineGroupedSummaryReducers,
    summary: summary_1.coreTimelineSummaryReducers,
    synopsis: synopsis_1.coreTimelineSynopsisReducers,
    userChanges: user_changes_1.coreTimelineUserChangesReducers
});
exports.coreTimelineWatchers = (0, xuder_1.combineAllWatchers)([
    details_1.coreTimelineDetailsWatchers,
    export_1.coreTimelineExportWatchers,
    grouped_summary_1.coreTimelineGroupedSummaryWatchers,
    summary_1.coreTimelineSummaryWatchers,
    synopsis_1.coreTimelineSynopsisWatchers,
    user_changes_1.coreTimelineUserChangesWatchers
]);
//# sourceMappingURL=index.js.map